import { Vault } from '@/features/vaults/types';
import { cbBtcTokenAddress } from '@/features/vaults/constants/vaults/mezo/tokens/cbBtcTokenAddress';
import { Hash } from '@/shared/types/Hash';

export const mezoCbBtcPreDepositVaultId = 'mezo-cbbtc-pre-deposit-vault';

export const mezoCbBtcPreDepositVaultAddress: Hash = '0x63a76a4a94cAB1DD49fcf0d7E3FC53a78AC8Ec5C';

export const mezoCbBtcPreDepositVault: Vault = {
  id: mezoCbBtcPreDepositVaultId,
  type: 'core-vault',
  category: 'core-vault',
  name: 'Mezo cbBTC Pre-Deposit Vault',
  description:
    'Bring It Home to Mezo with Highest BTC Yield onchain this season. Curated Bitcoin yield vault by Sense.capital. Deposits are deployed into onchain liquidity strategies like Mezo Tigris, Uniswap V4, Curve and Yield Basis.\n' +
    '<br /><br />' +
    'Curator: Sense Capital — Quantitative fund specializing in institutional-grade DeFi strategies. Focus on IL-minimized, full-reserve, diversified yield across blue-chip venues',
  address: mezoCbBtcPreDepositVaultAddress,
  network: 'ethereum',
  networks: [
    {
      network: 'ethereum',
      vaultAddress: mezoCbBtcPreDepositVaultAddress,
    },
  ],
  curators: ['mezo', 'sense'],
  operator: [],
  baseToken: cbBtcTokenAddress,
  depositTokens: [
    {
      address: cbBtcTokenAddress,
      decimals: 8,
      symbol: 'cbBTC',
    },
  ],
  points: [{ entity: 'mellow', startTimestamp: 1760967575 }],
  lpTokenSymbol: 'mbhcbBTC',
  lpTokenDecimals: 18,
  allocations: {
    showAllocationsTab: true,
  },
  oracleUpdateInterval: BigInt(86400),
  redeemHandlingInterval: BigInt(3600),
  isWithdrawDisabled: true,
  isInstantDeposit: true,
  withdrawalLock: {
    label: '2026 March 23',
    tooltip:
      'Vaults lock on January 26 for migration. Withdrawals will be available on Mezo after unlock on March 23.',
  },
  predictedApy: {
    value: 35,
    type: 'APY',
  },
  archived: true,
  deposit: {
    disabled: true,
  },
};
